import React from 'react';

interface SkeletonProps {
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => {
  return (
    <div 
      className={`animate-pulse bg-text-main/10 rounded-md ${className}`}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
